import HelmetComponent, { HelmetProps } from 'react-helmet'

const Helmet: React.FC<Omit<HelmetProps, 'titleTemplate' | 'defer'>> = (props) => (
    <HelmetComponent defer={false} titleTemplate="%s | Vividi" {...props} />
)

export default Helmet
